import { render } from "./manageUserProcesses.vue?vue&type=template&id=aee71242&scoped=true&ts=true"
import script from "./manageUserProcesses.vue?vue&type=script&lang=ts"
export * from "./manageUserProcesses.vue?vue&type=script&lang=ts"

import "./manageUserProcesses.vue?vue&type=style&index=0&id=aee71242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aee71242"]])

export default __exports__